/******************************************************************
 * Archivo : client/src/queries/fetchSurveyById.js
 * Proyecto: CB30
 * Módulo  : Encuestas
 * Proceso : Consulta de encuesta por ID
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query SurveyByIdQuery($id: ID!) {
    surveyById(id: $id) {
      id
      published
      titulo
      descripcion
      fecha
      tiempo

      parameterization {
        active
        profileType
        genero
        nivel_educativo
        estrato
        departamento
      }

      fieldcollection {
        id
        surveyId
        type
        inputName
        question

        answers {
          label
          value

          config {
            mostBeNum
            numMin
            numMax
            replica
            replicaLabel
          }
        }

        config {
          mostBeNum
          numMin
          numMax
          replica
          replicaLabel
        }
      }

      results {
        userId
        surveyResultsId
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchSurveyById.js